import React, { lazy, Suspense } from 'react';

const LazyTechSupportForm = lazy(() => import('./TechSupportForm'));

const TechSupportForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyTechSupportForm {...props} />
  </Suspense>
);

export default TechSupportForm;
